import { Divider, FormControl, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectOptions, setChartOrientation, setChartTime, setFluidRatio, setFluids, setShowForecast, setShowGroupWell, setShowLegend, setShowOutliers, setShowPressure, setShowTypeCurve } from '../reducers/optionsSlice';


const useStyles = makeStyles(theme => ({
  chartOptionsHorizontal: {
    position: 'relative', 
    zIndex: 69, 
    overflow: 'hidden',
    display: 'flex',
    flexWrap: 'wrap'
  },
}));

export const ProductionChartOptions = ({ list, darkMode, userEmail }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const options = useSelector(selectOptions);

  useEffect(() => {
    if (userEmail?.includes('ssdynamics.com') && options?.showOutliers === 'Hide') {
      dispatch(setShowOutliers('Show'));
    };
  }, []); //eslint-disable-line

  useEffect(() => {
    if (list) {
      if (list?.forecastListTab === 2 && options?.chartTime === 'Relative') {
        console.log('Changing chart time');
        handleChartTimeChange(undefined, 'Absolute');
      } else if (list?.forecastListTab === 1 && options?.chartTime === 'Absolute') {
        console.log('Changing chart time');
        handleChartTimeChange(undefined, 'Relative');
      };
    };
  }, [list]); //eslint-disable-line

  // const [showChartOptions, setShowChartOptions] = useState(false);


  const handleFluidRatioChange = (event, newRatio) => {
    newRatio && dispatch(setFluidRatio(newRatio));
  };
  // const handleChartFluidsChange = (event, newFluids) => {
  //   (newFluids.indexOf(options.fluid) !== -1) && dispatch(setFluids(newFluids));
  // };
  // const handleChartTypeChange = (event, newType) => {
  //   newType && dispatch(setChartType(newType));
  // };
  const handlePressureChange = (event, newPressure) => {
    newPressure && dispatch(setShowPressure(newPressure));
  };
  const handleChartTimeChange = (event, newTime) => {
    newTime && dispatch(setChartTime(newTime));
  };
  const handleShowLegendChange = (event, newLegend) => {
    newLegend && dispatch(setShowLegend(newLegend));
  };
  const handleShowOutliers = (event, newOutliers) => {
    newOutliers && dispatch(setShowOutliers(newOutliers));
  };
  const handleChartOrientationChange = (event, newOrientation) => {
    newOrientation && dispatch(setChartOrientation(newOrientation));
  };
  const handleShowTypeCurveChange = (event, newTypeCurve) => {
    newTypeCurve && dispatch(setShowTypeCurve(newTypeCurve));
  };
  const handleShowGroupWellChange = (event, newGroupWell) => {
    newGroupWell && dispatch(setShowGroupWell(newGroupWell));
  };
  const handleShowForecastChange = (event, newForecast) => {
    newForecast && dispatch(setShowForecast(newForecast));
  };
  const handleChartFluidsChange = (event, newFluids) => {
    try {
      newFluids && dispatch(setFluids({fluids: newFluids}));
    } catch (error) {
      console.log('Could not change chart fluids!');
    };
  };

  return (
    <div className={classes.chartOptionsHorizontal}>

      <FormControl style={{marginRight: 10, marginBottom: 5}}>
        <Typography variant="subtitle2" color="textSecondary" style={{fontWeight: 'bold', fontSize: 10}}>
          CHART FLUIDS
        </Typography>
        <ToggleButtonGroup
          value={options.fluids}
          onChange={handleChartFluidsChange}
          size="small"
          style={{height: 30, marginTop: 0}}
        >
          <ToggleButton value="oil" fontSize="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Oil
            </Typography>
          </ToggleButton>
          <ToggleButton value="gas" fontSize="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Gas
            </Typography>
          </ToggleButton>
          <ToggleButton value="condensate" fontSize="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Condensate
            </Typography>
          </ToggleButton>
          <ToggleButton value="water" fontSize="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Water
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl>
      
      <FormControl style={{marginRight: 10, marginBottom: 5}}>
        <Typography variant="subtitle2" color="textSecondary" style={{fontWeight: 'bold', fontSize: 10}}>
          FLUID RATIO
        </Typography>
        <ToggleButtonGroup
          value={options?.fluidRatio}
          onChange={handleFluidRatioChange}
          size="small"
          style={{height: 30, marginTop: 0}}
          exclusive
        >
          <ToggleButton value="Off" fontSize="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Off
            </Typography>
          </ToggleButton>
          <ToggleButton value="GOR" fontSize="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              GOR
            </Typography>
          </ToggleButton>
          <ToggleButton value="CGR" fontSize="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              CGR
            </Typography>
          </ToggleButton>
          <ToggleButton value="WOR" fontSize="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              WOR
            </Typography>
          </ToggleButton>
          <ToggleButton value="WGR" fontSize="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              WGR
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl>

      <FormControl component="fieldset" style={{marginRight: 10, marginBottom: 5}}>
        <Typography variant="subtitle2" color="textSecondary" style={{fontWeight: 'bold', fontSize: 10}}>
          PRESSURE
        </Typography>
        <ToggleButtonGroup
          value={options.showPressure}
          exclusive
          onChange={handlePressureChange}
          size="small"
          style={{height: 30, marginTop: 0}}
        >
          <ToggleButton value="Show" size="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Show
            </Typography>
          </ToggleButton>
          <ToggleButton value="Hide" size="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Hide
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl>

      <FormControl component="fieldset" style={{marginRight: 10, marginBottom: 5}}>
        <Typography variant="subtitle2" color="textSecondary" style={{fontWeight: 'bold', fontSize: 10}}>
          CHART TIME
        </Typography>
        <ToggleButtonGroup
          value={options.chartTime}
          exclusive
          onChange={handleChartTimeChange}
          size="small"
          style={{height: 30, marginTop: 0}}
        >
          <ToggleButton value="Relative" size="small" disabled={list?.forecastListTab === 2} color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Relative
            </Typography>
          </ToggleButton>
          <ToggleButton value="Absolute" size="small" color={(darkMode ? "" : "primary")} disabled={options.chartType === 'Rate-Cum.' || list?.forecastListTab === 1} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Absolute
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl>

      <FormControl style={{marginRight: 10, marginBottom: 5}}>
        <Typography variant="subtitle2" color="textSecondary" style={{fontWeight: 'bold', fontSize: 10}}>
          TYPE CURVE
        </Typography>
        <ToggleButtonGroup
          value={options.showTypeCurve}
          exclusive
          onChange={handleShowTypeCurveChange}
          size="small"
          style={{marginTop: 0, height: 30}}
        >
          <ToggleButton value={'Show'} size="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Show
            </Typography>
          </ToggleButton>
          <ToggleButton value={'Hide'} size="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Hide
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl>

      <FormControl style={{marginRight: 10, marginBottom: 5}}>
        <Typography variant="subtitle2" color="textSecondary" style={{fontWeight: 'bold', fontSize: 10}}>
          GROUP WELL
        </Typography>
        <ToggleButtonGroup
          value={options.showGroupWell || 'Hide'}
          exclusive
          onChange={handleShowGroupWellChange}
          size="small"
          style={{marginTop: 0, height: 30}}
        >
          <ToggleButton value={'Show'} size="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Show
            </Typography>
          </ToggleButton>
          <ToggleButton value={'Hide'} size="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Hide
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl>

      <FormControl style={{marginRight: 10, marginBottom: 5}}>
        <Typography variant="subtitle2" color="textSecondary" style={{fontWeight: 'bold', fontSize: 10}}>
          FORECAST
        </Typography>
        <ToggleButtonGroup
          value={options.showForecast || 'Hide'}
          exclusive
          onChange={handleShowForecastChange}
          size="small"
          style={{marginTop: 0, height: 30}}
        >
          <ToggleButton value={'Show'} size="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Show
            </Typography>
          </ToggleButton>
          <ToggleButton value={'Hide'} size="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Hide
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl>

      {/* <div style={{height: 35, borderRight: '1px solid lightgrey'}}></div> */}

      <FormControl style={{marginRight: 10, marginBottom: 5}}>
        <Typography variant="subtitle2" color="textSecondary" style={{fontWeight: 'bold', fontSize: 10}}>
          LEGEND
        </Typography>
        <ToggleButtonGroup
          value={options.showLegend}
          exclusive
          onChange={handleShowLegendChange}
          size="small"
          style={{marginTop: 0, height: 30}}
        >
          <ToggleButton value={'Show'} size="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Show
            </Typography>
          </ToggleButton>
          <ToggleButton value={'Hide'} size="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Hide
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl>

      <FormControl style={{marginRight: 10, marginBottom: 5, display: !userEmail?.includes('ssdynamics.com') && 'none'}}>
        <Typography variant="subtitle2" color="textSecondary" style={{fontWeight: 'bold', fontSize: 10}}>
          OUTLIERS
        </Typography>
        <ToggleButtonGroup
          value={options.showOutliers}
          exclusive
          onChange={handleShowOutliers}
          size="small"
          style={{marginTop: 0, height: 30}}
        >
          <ToggleButton value={'Show'} size="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Show
            </Typography>
          </ToggleButton>
          <ToggleButton value={'Hide'} size="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Hide
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl>

      <FormControl style={{marginRight: 10, marginBottom: 5}}>
        <Typography variant="subtitle2" color="textSecondary" style={{fontWeight: 'bold', fontSize: 10}}>
          CHART LAYOUT
        </Typography>
        <ToggleButtonGroup
          value={options.chartOrientation}
          exclusive
          onChange={handleChartOrientationChange}
          size="small"
          style={{marginTop: 0, height: 30}}
        >
          <ToggleButton value={'Horizontal'} size="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Horizontal
            </Typography>
          </ToggleButton>
          <ToggleButton value={'Vertical'} size="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Vertical
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl>
      <Divider style={{marginTop: 10}} />
    </div>
  );

};
